import { render, staticRenderFns } from "./printshippingselected.vue?vue&type=template&id=476aa627&"
import script from "./printshippingselected.vue?vue&type=script&lang=js&"
export * from "./printshippingselected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports